import React, { ChangeEvent, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Tooltip,
} from '@mui/material'
import {
  reinstateDistricts,
  reinstateSchools,
  reinstateUsers,
  reinstateDemos,
} from '../../../providers/mutations'

const ReinstateResourceButton = ({
  name,
  resource,
  schoolID,
  districtID,
  userID,
  demoID,
}: {
  name: string
  resource: string
  schoolID?: number
  districtID?: number
  userID?: number
  demoID?: number
}) => {
  const [open, setOpen] = useState(false)
  const [reinstateUser, setReinstateUser] = useState(true)
  const [reinstateSchool, setReinstateSchool] = useState(true)
  const redirect = () => {
    setOpen(false)
    window.location.reload()
  }

  const doReinstate = async () => {
    if (schoolID) {
      await reinstateSchools({
        school_ids: [schoolID],
        reinstate_users: reinstateUser,
      })
    } else if (districtID) {
      await reinstateDistricts({
        district_ids: [districtID],
        reinstate_schools: reinstateSchool,
        reinstate_users: reinstateUser,
      })
    } else if (userID) {
      await reinstateUsers({ user_ids: [userID] })
    } else if (demoID) {
      await reinstateDemos({ demo_ids: [demoID] })
    }
    redirect()
  }
  const title = 'Are you sure you want to reinstate this ' + resource + '?'
  const buttonText = 'Reinstate ' + resource

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onReinstateSchoolChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReinstateSchool(event.target.checked)
  }

  const onReinstateUserChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReinstateUser(event.target.checked)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog onClose={handleClose} open={open} data-testid="dialog">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span>
              {resource} Name: {name}
            </span>
          </DialogContentText>
          <Box>
            {districtID && (
              <Tooltip
                title="Select this option to reinstate schools"
                placement="right-start"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={reinstateSchool}
                      onChange={onReinstateSchoolChange}
                      name="reinstateSchool"
                    />
                  }
                  label="Reinstate Schools"
                />
              </Tooltip>
            )}
            {(districtID || schoolID) && (
              <Tooltip
                title="Select this option to reinstate users"
                placement="right-start"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={reinstateUser}
                      onChange={onReinstateUserChange}
                      name="reinstateUser"
                    />
                  }
                  label="Reinstate Users"
                />
              </Tooltip>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={doReinstate}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ReinstateResourceButton
